module.exports = __webpack_public_path__ + "static/media/clinician-rhythm-1080p.6b987c64.mp4";